import { Box, Text } from '@chakra-ui/react';
import { RiMapPin2Fill } from 'react-icons/ri';
import React from 'react';

const ContactAddress = ({city,state,postal_code}) => {
  if(typeof city === 'undefined' && typeof state === 'undefined'  && typeof postal_code ===  'undefined') {
    return null;
  }
  if (typeof city !== 'undefined' && city !== '') {
    city = city + ','
  }
  return (
    <Box className='linkWrapper' >
      <Text className='linkText' ><RiMapPin2Fill />  </Text><Text >{city} {state} {postal_code}</Text></Box>
  );
}
export default ContactAddress;